<div class="tile">
  <h5 class="mb-4 font-medium">
    {{ 'instrument-detail.instrument-base-data.headline' | transloco }}
  </h5>
  @if (model?.instrumentType === InstrumentType.Crypto && model?.shortName; as shortName) {
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.shortName' | transloco }}</div>
      <div class="font-medium text-right" data-zid="base-data-short-name">{{ shortName }}</div>
    </div>
  } @else {
    @if (model?.wkn; as wkn) {
      <div class="d-flex d-lg-block d-xl-flex justify-content-between">
        <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.wkn' | transloco }}</div>
        <div class="font-medium text-right">
          <web-design-system-copy-to-clipboard [label]="wkn" [hint]="'instrument-detail.instrument-header.copy-wkn' | transloco" />
        </div>
      </div>
    }
    @if (model?.isin; as isin) {
      <hr class="less-margin" />
      <div class="d-flex d-lg-block d-xl-flex justify-content-between">
        <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.isin' | transloco }}</div>
        <div class="font-medium text-right">
          <web-design-system-copy-to-clipboard [label]="isin" [hint]="'instrument-detail.instrument-header.copy-isin' | transloco" />
        </div>
      </div>
    }
  }
  @if (model?.branches; as branches) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.branches' | transloco }}</div>
      <div class="font-medium text-right">{{ branches }}</div>
    </div>
  }
  @if (model?.country; as country) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.country' | transloco }}</div>
      <div class="font-medium text-right">{{ country }}</div>
    </div>
  }
  @if (model?.emittent; as emittent) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.emittent' | transloco }}</div>
      <div class="font-medium text-right">{{ emittent }}</div>
    </div>
  }
  @if (model?.ter; as ter) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.ter' | transloco }}</div>
      <div class="font-medium text-right">{{ ter | number }} %</div>
    </div>
  }
  @if (model?.setupCountry; as setupCountry) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.setupCountry' | transloco }}</div>
      <div class="font-medium text-right">{{ setupCountry }}</div>
    </div>
  }
  @if (model?.releaseDate; as releaseDate) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.releaseDate' | transloco }}</div>
      <div class="font-medium text-right">{{ releaseDate * 1000 | date }}</div>
    </div>
  }
  @if (model?.category; as category) {
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.category' | transloco }}</div>
      <div class="font-medium text-right">{{ category }}</div>
    </div>
  }
  @if (model?.volume; as volume) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.volume' | transloco }}</div>
      <div class="font-medium text-right">{{ volume.value | bigNumbers: '1.2-2' }} {{ model.volume.symbol | currencySymbol }}</div>
    </div>
  }
  @if (model?.manager; as manager) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.manager' | transloco }}</div>
      <div class="font-medium text-right">{{ manager }}</div>
    </div>
  }
  @if (model?.replication; as replication) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-base-data.rows.replication' | transloco }}
      </div>
      <div class="font-medium text-right">{{ model.replication }}</div>
    </div>
  }
  @if (model?.isAccumulating !== undefined) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.isAccumulating' | transloco }}</div>
      <div class="font-medium text-right">{{ model?.isAccumulating ? 'Ja' : 'Nein' }}</div>
    </div>
  }
  @if (model?.productType; as productType) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.productType' | transloco }}</div>
      <div class="font-medium text-right">{{ productType }}</div>
    </div>
  }
  @if (model?.investmentDirection; as investmentDirection) {
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.investmentDirection' | transloco }}</div>
      <div class="font-medium text-right">{{ investmentDirection }}</div>
    </div>
    <hr class="less-margin" />
  }
  @if (model?.ratio; as ratio) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.ratio' | transloco }}</div>
      <div class="font-medium text-right">{{ ratio | number }}</div>
    </div>
  }
  @if (model?.typeOfSettlement; as typeOfSettlement) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.typeOfSettlement' | transloco }}</div>
      <div class="font-medium text-right">{{ typeOfSettlement }}</div>
    </div>
  }
  @if (model?.typeOfExercise; as typeOfExercise) {
    <hr class="less-margin" />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">{{ 'instrument-detail.instrument-base-data.rows.typeOfExercise' | transloco }}</div>
      <div class="font-medium text-right">{{ typeOfExercise }}</div>
    </div>
  }
  @if (model?.instrumentType === InstrumentType.Derivative) {
    <hr class="less-margin" />
    <div class="text-color-primary text-size-small" data-zid="base-data-derivative-hint">
      {{ 'instrument-detail.instrument-base-data.derivative-hint' | transloco }}
    </div>
  }
</div>
